module.exports = ["Villa"];



// WEBPACK FOOTER //
// ./src/data/villa.js